import "@/App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import Assistant from "@/pages/Assistant";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Compte from "@/pages/Compte";
import MesClients from "@/pages/MesClients";
import ResetPassword from "@/pages/ResetPassword";
import { AuthProvider } from "@/context/AuthContext";

function CrashFallback({ onReset }) {
  useEffect(() => {
    toast.error("Un souci est survenu, retour à l'accueil.");
    const t = setTimeout(onReset, 1800);
    return () => clearTimeout(t);
  }, [onReset]);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-[#faf7f1]">
      <div className="font-heading text-3xl font-extrabold tracking-[0.25em] text-[#2b2b2b]">
        FA<span className="text-[#9E7B41]">U</span>TRAS
      </div>
      <p className="text-xs tracking-[0.3em] uppercase text-[#9E7B41] mt-1">Complice du cheval</p>
      <p className="text-muted-foreground mt-6 max-w-sm">
        Une erreur est survenue lors du calcul. Retour automatique à la page d'accueil…
      </p>
      <button
        data-testid="crash-home-button"
        onClick={onReset}
        className="mt-6 bg-[#9E7B41] hover:bg-[#876634] text-white h-12 px-7 rounded-xl font-semibold transition-colors"
      >
        Revenir à l'accueil
      </button>
    </div>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("App crash caught by ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return <CrashFallback onReset={this.props.onReset} />;
    }
    return this.props.children;
  }
}

function App() {
  const [resetKey, setResetKey] = useState(0);
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route
              path="/"
              element={
                <ErrorBoundary key={resetKey} onReset={() => setResetKey((k) => k + 1)}>
                  <Assistant />
                </ErrorBoundary>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/compte" element={<Compte />} />
            <Route path="/mes-clients" element={<MesClients />} />
            <Route path="/mot-de-passe-oublie" element={<ResetPassword />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
